import React, { FC, useEffect, useContext } from "react";
import CustomTabMenu from "../../../../component/CustomTabMenu";
import KhamBenh from "./KhamBenh";
import CDHA from "./CDHA";
import XetNghiem from "./XetNghiem";
import "./KhamLamSang.scss"
import { Button } from "react-bootstrap";
import { AppContext } from "../../../../appContext/AppContext";
import { CODE, RESPONSE_MESSAGE } from "../../../../utils/Constant";
import { startKhamBenh, updateWfWorkflows, getWfWorkflows, updateSummaryContract } from "../services/KhamLamSangSevice"
import { KhamLamSangContext, KhamLamSangContextProps } from "../KhamLamSang";
import { PhanHeKhamDoanContext, PhanHeKhamDoanContextProps } from "../../../PhanHeKhamDoan";
import { toast } from "react-toastify";
import SoKhamSucKhoe from "./SoKhamSucKhoe";
import { WF_STATUS } from "../../../constants/PhanHeKhamDoan";
import WfButton from "../../../../workflows/components/WfButton";
import { WfConstTracker } from "../../../../workflows/Constant";


type KhamLamSangTabProps = {
  setActiveTab?: any,
}
const KhamLamSangTab: FC<KhamLamSangTabProps> = React.memo(
  ({
    setActiveTab,
  }) => {

    const { setIsLoading } = useContext(AppContext);
    const { TTNhanVien, setTTNhanVien, TTHopDong, setIsSearchNV, isSearchNV } = useContext<KhamLamSangContextProps>(KhamLamSangContext)
    const { setWorkFlowStatus, workFlowStatus } = useContext<PhanHeKhamDoanContextProps>(PhanHeKhamDoanContext)

    const handlerStartKhamBenh = (currStatusCode: any, listResponse: any) => {
      if(currStatusCode === WF_STATUS.DANG_KHAM.CODE) {
        setTTNhanVien({
          ...TTNhanVien,
          encounter: {
            ...TTNhanVien?.encounter,
            id: listResponse?.encounter?.id,
          }
        })
      }
      else if(currStatusCode === WF_STATUS.CHUA_KHAM.CODE){
        setTTNhanVien({
          ...TTNhanVien,
          wfTracker: listResponse
        });
        setWorkFlowStatus(listResponse);
      }
      setIsSearchNV(!isSearchNV);

    }

    const listTab = [
      {
        title: 'Khám bệnh',
        component: <KhamBenh />
      },
      {
        title: 'Sổ khám sức khoẻ',
        component: <SoKhamSucKhoe />
      },
      {
        title: 'Xét nghiệm',
        component: <XetNghiem />
      },
      {
        title: 'CĐHA-TDCN',
        component: <CDHA />
      },
    ];

    return (
      <div className="reception-list__container spaces   bg-white">
        <div className="d-flex border-bottom spaces pl-10 pr-15  gap-10">
          <h4 className="text-title-kls fw-bold fs-4 spaces my-5">
            {`Khám lâm sàng | ${TTHopDong?.companyName}`}
          </h4>
          <div className="d-flex justify-content-end align-items-center flex-grow-1">
            <WfButton
              tracker={WfConstTracker.PHY_CLINICAL}
              objectId={TTNhanVien?.orderId}
              additionalProps={
                {
                  patientId: TTNhanVien?.patient?.id || "",
                  visitId: TTNhanVien?.visit?.id || "",
                }
              }
              additionalFunc={(codeRequest, codeBtn, listResponse) => {
                handlerStartKhamBenh(codeRequest, listResponse)
              }}
            ></WfButton>
            <Button className="mx-2 btn-fill  spaces min-w-60 h-29 "
            >
              <span>In</span>
            </Button>
          </div>
        </div>
        <div className="bg-white spaces py-5 gap-10">
          <CustomTabMenu classTittle="spaces ml-10" danhsachTabs={listTab} childrenTab={true} />
        </div>
      </div>
    );
  }
);
export default KhamLamSangTab;
